<template>
    <div class="talbe-filter">
        <div class="talbe-filter--group">
            <select-input
                class="direct-referral__input"
                :placeholder="$t('forms.auth.register.fields.specialty.label')"
                :options="specialities"
                :groupOptions="false"
                :isSearchable="true"
                :expandOptionsLeft="true"
                :isNullable="true"
                :value="specialityId"
                icon="bell"
                @change="specialtyChanged($event)"
            ></select-input>
            <select-input
                class="direct-referral__input"
                :placeholder="$t('forms.auth.practice.fields.insurance_plans.label')"
                :options="insurancePlans"
                :groupOptions="true"
                :expandOptionsLeft="true"
                :isSearchable="true"
                :isNullable="true"
                :value="insuranceId"
                icon="insurance"
                @change="changeInsurance($event)"
            ></select-input>
            <text-input
                v-model="zipCode"
                class="direct-referral__input"
                :placeholder="$t('pages.network.ehr.table.search_zip_code')"
                type="text"
                @change="changeZipCode($event)"
            ></text-input>
        </div>
        <select-input
            class="direct-referral__input"
            :placeholder="''"
            :options="paginationOptions"
            :groupOptions="false"
            :isSearchable="false"
            :isNullable="false"
            :value="pageSize"
            @change="changePagination($event)"
        ></select-input>
    </div>
</template>

<script>
    import SpecialitiesAPI from 'api/SpecialitiesAPI'
    import InsurancePlansAPI from 'api/InsurancePlanGroupsAPI'
    import PageWithDataMixin from 'mixins/PageWithDataMixin'
    import SelectInput from 'components/form-inputs/SelectInput'
    import TextInput from 'components/form-inputs/TextInput'
    import debounce from 'lodash/debounce'
    import config from '../../../config'

    export default {
        mixins: [PageWithDataMixin],
        components: { SelectInput, TextInput },

        props: {},

        data() {
            return {
                specialities: [],
                insurancePlans: [],
                paginationOptions: [],
                specialityId: null,
                insuranceId: null,
                zipCode: null,
                pageSize: 5,
            }
        },

        methods: {
            specialtyChanged(event) {
                this.specialityId = event
                this.filterChanged()
            },

            changeInsurance(event) {
                this.insuranceId = event
                this.filterChanged()
            },

            changePagination(event) {
                this.pageSize = event
                this.filterChanged()
            },

            changeZipCode: debounce(function (event) {
                this.zipCode = event
                if (this.zipCode.length === 5 || this.zipCode.length === 0) {
                    this.filterChanged()
                }
            }, config.DEBOUNCE.DEFAULT),

            filterChanged() {
                this.emitEvent({
                    name: 'filter-changed',
                    payload: {
                        specialityId: this.specialityId,
                        insuranceId: this.insuranceId,
                        pageSize: this.pageSize,
                        zipCode: this.zipCode,
                    },
                })
            },

            getSpecialites() {
                SpecialitiesAPI.getListMultiselect().then((res) => {
                    this.specialities = res.map((el) => {
                        return {
                            value: el.value,
                            label: el.label,
                            options: {
                                value: el.value,
                                label: el.label,
                            },
                        }
                    })
                })
            },

            getInsurancePlans() {
                InsurancePlansAPI.getList().then((val) => {
                    this.insurancePlans = val
                })
            },
        },

        mounted() {
            this.getSpecialites()
            this.getInsurancePlans()
            this.paginationOptions = [
                {
                    value: 5,
                    label: `5 ${this.$t('pages.network.ehr.table.per_page')}`,
                    options: {
                        value: 5,
                        label: `5 ${this.$t('pages.network.ehr.table.per_page')}`,
                    },
                },
                {
                    value: 10,
                    label: `10 ${this.$t('pages.network.ehr.table.per_page')}`,
                    options: {
                        value: 10,
                        label: `10 ${this.$t('pages.network.ehr.table.per_page')}`,
                    },
                },
                {
                    value: 20,
                    label: `20 ${this.$t('pages.network.ehr.table.per_page')}`,
                    options: {
                        value: 20,
                        label: `20 ${this.$t('pages.network.ehr.table.per_page')}`,
                    },
                },
            ]
        },
    }
</script>

<style lang="scss">
    .talbe-filter {
        display: flex;
        justify-content: space-between;

        &--group {
            display: flex;
            justify-content: space-between;

            .direct-referral__input {
                margin-right: 10px;
            }
        }
    }
</style>
